export default __webpack_public_path__ + "static/media/math-text-blue.bb4c498f.svg";